import { Component, Inject } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-debit-voucher-issues',
  templateUrl: './debit-voucher-issues.component.html',
  styleUrl: './debit-voucher-issues.component.scss'
})
export class DebitVoucherIssuesComponent {

  issues: any[] = [];
  pagedIssues: any[] = [];

  loading = false;
  hasData = false;

  // pagination
  currentPage = 1;
  pageSize = 10;   // rows per page
  totalPages = 0;
  startDate: any;
  endDate: any;

  constructor(private service: DigisubservicesService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DebitVoucherIssuesComponent>,
    private snack: MatSnackBar,
  ) { }

  ngOnInit(): void {

    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;

    this.loadIssues();
  }

  loadIssues() {

    const request = {
      startdate: this.startDate,
      enddate: this.endDate
    };

    this.loading = true;

    const startTime = Date.now(); // loader start time

    this.service.detectDVIssues(request).subscribe({
      next: (res: any) => {

        this.issues = res?.data || [];
        this.hasData = this.issues.length > 0;
        this.totalPages = Math.ceil(this.issues.length / this.pageSize);
        this.setPage(1);

        this.loading = false;

      },

      error: (err) => {
        console.error('DV Issue API Error:', err);

        this.issues = [];
        this.hasData = false;
        this.loading = false;

      }
    });
  }

  setPage(page: number) {
    if (page < 1 || page > this.totalPages) return;

    this.currentPage = page;
    const start = (page - 1) * this.pageSize;
    const end = start + this.pageSize;

    this.pagedIssues = this.issues.slice(start, end);
  }

  nextPage() {
    this.setPage(this.currentPage + 1);
  }

  prevPage() {
    this.setPage(this.currentPage - 1);
  }

  openVoucher(row: any) {
    this.dialogRef.close(row);
  }

}